// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--1-_IY","title":"a10a3f92e9--title--2_HKz","text":"a10a3f92e9--text--3fh7I"};